import CountUp from 'react-countup'

export default function Metric({ label = '', value = '' }) {
  const start = value - 400

  return (
    <div className="min-w-[142px]">
      <CountUp
        start={start < 0 ? 0 : start}
        end={value}
        duration={5}
        separator=""
        className="heading1 leading-none mb-5 lg:mb-3 text-[120px] lg:text-[70px] aic-2k:text-[120px] mb-1 block text-white"
      />

      <span className="paragraph  block text-white text-nowrap">{label}</span>
    </div>
  )
}
